import { Chart } from "chart.js";

export const strip_empty_label_plugin = function (
  this: {
    generateLabels: (chart: Chart<"scatter">) => {
      text: string | undefined;
      fillStyle:
        | string
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => import("chart.js").Color | undefined)
        | import("chart.js/types/utils")._DeepPartialObject<CanvasGradient>
        | import("chart.js/types/utils")._DeepPartialObject<CanvasPattern>
        | readonly (
            | string
            | import("chart.js/types/utils")._DeepPartialObject<CanvasGradient>
            | import("chart.js/types/utils")._DeepPartialObject<CanvasPattern>
            | undefined
          )[]
        | undefined;
      hidden: boolean;
      lineCap:
        | "butt"
        | "round"
        | "square"
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => CanvasLineCap | undefined)
        | undefined;
      lineDash:
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => number[] | undefined)
        | import("chart.js/types/utils")._DeepPartialArray<number>
        | undefined;
      lineDashOffset:
        | number
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => number | undefined)
        | undefined;
      lineJoin:
        | "round"
        | "bevel"
        | "miter"
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => CanvasLineJoin | undefined)
        | undefined;
      lineWidth:
        | number
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => number | undefined)
        | readonly (number | undefined)[]
        | undefined;
      strokeStyle:
        | string
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => import("chart.js").Color | undefined)
        | import("chart.js/types/utils")._DeepPartialObject<CanvasGradient>
        | import("chart.js/types/utils")._DeepPartialObject<CanvasPattern>
        | readonly (
            | string
            | import("chart.js/types/utils")._DeepPartialObject<CanvasGradient>
            | import("chart.js/types/utils")._DeepPartialObject<CanvasPattern>
            | undefined
          )[]
        | undefined;
      pointStyle:
        | "line"
        | "circle"
        | "cross"
        | "crossRot"
        | "dash"
        | "rect"
        | "rectRounded"
        | "rectRot"
        | "star"
        | "triangle"
        | ((
            ctx: import("chart.js").ScriptableContext<"line">,
            options: import("chart.js/types/basic").AnyObject,
          ) => import("chart.js").PointStyle | undefined)
        | import("chart.js/types/utils")._DeepPartialObject<HTMLImageElement>
        | import("chart.js/types/utils")._DeepPartialObject<HTMLCanvasElement>
        | readonly (
            | "line"
            | "circle"
            | "cross"
            | "crossRot"
            | "dash"
            | "rect"
            | "rectRounded"
            | "rectRot"
            | "star"
            | "triangle"
            | import("chart.js/types/utils")._DeepPartialObject<HTMLImageElement>
            | import("chart.js/types/utils")._DeepPartialObject<HTMLCanvasElement>
            | undefined
          )[]
        | undefined;
      // Below is extra data used for toggling the datasets
      datasetIndex: number;
    }[];
  },
  chart: Chart<"scatter">,
) {
  const data = chart.data;
  const helper = {
    isArray: Array.isArray
      ? Array.isArray
      : function (value: any) {
          return Object.prototype.toString.call(value) === "[object Array]";
        },
  };

  const res = helper.isArray(data.datasets)
    ? data.datasets.map(function (dataset, i) {
        return {
          text: dataset.label,
          fillStyle: dataset.backgroundColor,
          hidden: !chart.isDatasetVisible(i),
          lineCap: dataset.borderCapStyle,
          lineDash: dataset.borderDash,
          lineDashOffset: dataset.borderDashOffset,
          lineJoin: dataset.borderJoinStyle,
          lineWidth: dataset.borderWidth,
          strokeStyle: dataset.borderColor,
          pointStyle: dataset.pointStyle,

          // Below is extra data used for toggling the datasets
          datasetIndex: i,
        };
      }, this)
    : [];
  return res.filter(function (opt) {
    return opt.text !== "";
  }); // Only show labels that have a non-empty text (e.g. filter out some windrange labels)
};
